'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishAllMessagesInHistoryToChannel = undefined;

var _setThreadId = require('conversations-schema/pubnub-message/operators/setThreadId');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _publishMessageToConversation = require('../../actions/PublishActions/publishMessageToConversation');

var publishAllMessagesInHistoryToChannel = exports.publishAllMessagesInHistoryToChannel = function publishAllMessagesInHistoryToChannel(_ref) {
  var channel = _ref.channel,
      history = _ref.history,
      threadId = _ref.threadId;
  return function (dispatch) {
    if ((0, _hasMessages.hasMessages)(history)) {
      (0, _getMessages.getMessages)(history).forEach(function (message) {
        dispatch((0, _publishMessageToConversation.publishMessageToConversation)({
          channel: channel,
          message: (0, _setThreadId.setThreadId)(threadId, message)
        }));
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/actions/publishAllMessagesInHistoryToChannel.js
// module id = 524
// module chunks = 2 3